<template>
  <v-flex v-if="companyChart" mt-xs-5>
    <h4 class="text-18-security blue-security text-xs-center font-weight-bold pt-4">
      RELACIONADOS
    </h4>
    <br />
    <!-- Father -->
    <v-layout row wrap justify-center v-if="parents.father.length">
      <v-flex xs12 md2>
        <CardUserFather
          :user="parents.father[0]"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
        />
      </v-flex>
    </v-layout>
    <!-- End Father -->
    <hr v-if="parents.siblings.length" class="mt-4 mb-4" />
    <!-- User and siblings -->
    <v-layout class row wrap justify-center v-if="parents.siblings.length">
      <v-flex md2 mr-2 pt-2>
        <CardUserSibling
          :user="currentUser"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
          :isCurrentUser="true"
        />
      </v-flex>
      <v-flex md2 mr-2 pt-2 v-for="sibling in parents.siblings" :key="sibling.id">
        <CardUserSibling 
          :user="sibling"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
          :isCurrentUser="false"
        />
      </v-flex>
    </v-layout>
    <!-- End selected_user and siblings -->
    <hr v-if="parents.childrens.length" class="mt-4 mb-4" />
    <!-- Childrens -->
    <v-layout row wrap justify-center v-if="parents.childrens.length">
      <v-flex md2 mr-2 pt-2 v-for="children in parents.childrens" :key="children.id">
        <CardUserChildren
          :user="children"
          :showUser="showUser"
          :scrollToTop="scrollToTop"
        />
      </v-flex>
    </v-layout>
    <!-- End Childrens -->
  </v-flex>
</template>

<script>
import { mapActions } from "vuex";
import CardUserFather from '@/components/User/CardUserFather';
import CardUserSibling from '@/components/User/CardUserSibling';
import CardUserChildren from '@/components/User/CardUserChildren';

export default {
  components: {
    CardUserFather,
    CardUserSibling,
    CardUserChildren,
  },
  props: {
    parents: {
      type: Object,
      required: true,
    },
    companyChart: {
      type: Boolean,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    }
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    showUser(user) {
      this.fetchUser(user.id);
      this.$router.push({
        name: "user-show",
        params: { id: user.id }
      });
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
}
</script>